<div class="alertas-container">
  <h2 class="alertas-title headline-medium font-brand weight-bold">{{ title() | translate }}</h2>

  <div class="alertas-icon-wrapper">
    <img [src]="iconUrl()" [alt]="'Icono de advertencia' | translate" width="74" height="64" class="alertas-icon">
  </div>

  <div class="alertas-content">
    <p class="alertas-message body-large weight-bold">{{ message() | translate }}</p>
    @if (subtitle()) {
      <p class="alertas-subtitle body-medium text-secondary">{{ subtitle() | translate }}</p>
    }
  </div>

  <div class="alertas-actions" [class.single-action]="!showCancel()">
    @if (showCancel()) {
      <button type="button" class="outlined btn-action" (click)="onCancel()">
        {{ cancelText() | translate }}
      </button>
    }
    <button type="button" class="filled btn-action" (click)="onConfirm()">
      {{ confirmText() | translate }}
    </button>
  </div>
</div>
